import { getObraImageUrl } from '@/utils/image-utils';
import type { ListCard } from './types';

export const pluralWorks = (n: number) => (n === 1 ? '1 obra' : `${n} obras`);

export const pluralFollowers = (n: number) => (n === 1 ? '1 seguidor' : `${n} seguidores`);

/** Shape mínimo vindo da API de listas da coleção */
export type ListaLike = {
    id: number;
    nome: string;
    descricao?: string | null;
    publica: boolean;
    total_obras?: number;
    total_seguidores?: number;
    obras?: { id: number; imagem: string | null }[];
};

export function listaLikeToListCard(lista: ListaLike): ListCard {
    const obras = lista.obras ?? [];
    const worksCount = lista.total_obras ?? obras.length;
    const covers = obras
        .slice(0, 4)
        .map((o) => getObraImageUrl(o.id, o.imagem ?? undefined, 400))
        .filter((u): u is string => Boolean(u && u.length > 0));

    return {
        id: String(lista.id),
        name: lista.nome,
        description: lista.descricao?.trim() || undefined,
        isPrivate: !lista.publica,
        worksCount,
        followers: lista.total_seguidores ?? 0,
        covers,
    };
}

const PLACEHOLDER_OBRA = '/placeholder-book.jpg';

function parsePreviewObraId(obra: { id?: number; obr_id?: number }): number | null {
    const raw = obra.id ?? obra.obr_id;
    if (raw == null) return null;
    const n = typeof raw === 'number' ? raw : Number.parseInt(String(raw), 10);
    return Number.isFinite(n) && n >= 1 ? n : null;
}

/** Listas públicas (ex.: `listas/publicas`) — mesma lógica de capa que `ListasPage` usava. */
export function publicListaToListCard(lista: {
    id: number;
    nome: string;
    descricao?: string | null;
    publica: boolean;
    total_obras: number;
    total_seguidores: number;
    obras?: { id?: number; obr_id?: number; imagem?: string | null; capa?: string | null }[];
}): ListCard {
    const obras = lista.obras ?? [];
    const covers = obras.slice(0, 4).map((obra) => {
        const file = obra.imagem ?? obra.capa;
        if (file && typeof file === 'string') {
            const trimmed = file.trim();
            if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
            const oid = parsePreviewObraId(obra);
            if (oid != null && trimmed.length > 0) {
                return getObraImageUrl(oid, trimmed, 400) ?? PLACEHOLDER_OBRA;
            }
        }
        return '';
    }).filter((u) => u.length > 0);

    return {
        id: String(lista.id),
        name: lista.nome,
        description: lista.descricao?.trim() || undefined,
        isPrivate: !lista.publica,
        worksCount: lista.total_obras,
        followers: lista.total_seguidores,
        covers,
    };
}
